<template>
  <b-modal
    v-model="show"
    ref="modal-import-excel"
    :title="$t('Import Excel')"
    @hidden="$emit('hidden')"
    ok-title="Import"
    @ok.prevent="saveExcel"
    scrollable
  >
    <b-row>
      <b-col cols="12">
        <b-form-group :label="$t('File')">
          <b-form-file
            v-model="file"
            :placeholder="$t('Choose a file or drop it here...')"
            drop-placeholder="Choose an excel..."
            :browse-text="$t('Browse')"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
// import modalMixin from "@/mixins/modal";
import schedulesService from "@/views/rrhh/views/attendance/services/attendance.service.js";
export default {
  name: "ModaImportExcel",
  //   mixins: [modalMixin],
  data() {
    return {
      file: null,
      show: true,
    };
  },
  mounted() {
    // this.toggleModal("modal-import-excel");
  },
  methods: {
    async saveExcel() {
      try {
        this.addPreloader();
        const formData = new FormData();
        formData.append("file", this.file);
        const { data, status } = await schedulesService.getScheduleInfo(
          formData
        );
        if (status === 200) {
          this.showToastSuccess(this.$t(data.message), "Success");
        }
        this.$emit("reload-schedules");
      } catch (error) {
        this.showToastError(this.$t(error.response.data.message), "Error");
      } finally {
        this.removePreloader();
      }
    },
  },
};
</script>

<style>
</style>